import React from "react";
import MainNav from "./MainNav";
import styled from "styled-components";
const HeaderWrapper = styled.header`
  border-bottom: 1px solid #CCCCCC;
`;
const Header = () => {
  return (
    <HeaderWrapper>
      <MainNav />
    </HeaderWrapper>
  );
};

export default Header;
